import { useTheme } from '@mui/material/styles';

import { useCognitoContext } from '../context/CognitoContext';
import { getStatusTypographyStyle } from '../components/HealthCheck/helpers';

import useHealthCheck from './useHealthCheck';

/**
 * Polls health for one URL and derives its themed status color.
 * The main readiness banner opts in to sharing this status with global polling logic.
 */
const useHealthStatus = (url, { updateGlobalHealthStatus = false } = {}) => {
  const theme = useTheme();
  const { signOut } = useCognitoContext();
  const { healthStatus, progress } = useHealthCheck(url, signOut, {
    updateGlobalHealthStatus,
  });
  const statusColor = getStatusTypographyStyle(healthStatus, theme).color;

  return { healthStatus, progress, statusColor };
};

export default useHealthStatus;
